type DeepBranding = 'interrisk';

export const DEEP_BRANDING: { [key in DeepBranding]: DeepBranding } = {
  interrisk: 'interrisk',
};
